import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { XCircle, Flame } from "lucide-react";
import SalesAssistant from "@/components/SalesAssistant";
import HesitationRescuer from "@/components/HesitationRescuer";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#08090d] text-white flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="card-glow-border rounded-3xl p-10 lg:p-14 max-w-lg w-full text-center"
      >
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-[#f97316] to-[#ea580c] shadow-[0_0_48px_rgba(255,98,31,0.5)] mb-8">
          <Flame size={28} className="text-white" strokeWidth={2.2} />
        </div>
        <XCircle size={40} className="text-slate-500 mx-auto mb-6" />
        <h1 className="font-display font-bold text-2xl sm:text-3xl mb-3" data-testid="payment-cancel-title">Checkout canceled.</h1>
        <p className="text-slate-400 text-sm sm:text-base mb-10" data-testid="payment-cancel-message">
          No charge was made. Your property's line of defense is still one click away whenever you're ready.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-to-site-link"
          className="inline-flex items-center gap-2.5 font-display font-bold tracking-[0.12em] text-sm px-8 py-4 rounded-full bg-gradient-to-r from-[#f97316] to-[#ea580c] text-white shadow-[0_8px_40px_rgba(255,98,31,0.4)] hover:shadow-[0_8px_56px_rgba(255,98,31,0.65)] transition-shadow duration-300"
        >
          BACK TO NOXWAY
        </Link>
      </motion.div>
      <SalesAssistant />
      <HesitationRescuer force="checkout_abandoned" />
    </div>
  );
}
